import styled from 'styled-components';
import {
  TextField as MuiTextField, Button as MuiButton,
  FormControlLabel as MuiFormControlLabel, Paper as MuiPaper
} from '@material-ui/core';

export { Select } from './Select';
export { Input } from './Input';
export { InputForm } from './InputForm';
export { InputSearch } from './InputSearch';
export { Switch } from './Switch';
export { Checkbox } from './Checkbox';
export { InputMask } from './InputMask';
export { PhoneInput } from './PhoneInput';


export const TextField = styled(MuiTextField)`
  & .MuiInputBase-input {
    box-shadow: none;
    -webkit-box-shadow: none;
    font-size: 1.4rem;
    font-weight: 500;
    text-transform: uppercase;
  }

  & .MuiInputBase-root {
    font-size: 1.2rem;
  }
  
  & .MuiInputLabel-root {
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
    /* @media(min-width: 1920px) {
      font-size: 1.6rem;
    } */
  }

  & .MuiInputLabel-outlined {
    transform: translate(14px, 18px) scale(1);
  }

  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.75);
  }

  & .MuiOutlinedInput-input {
    padding: 16px 14px;
  }


  & .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    font-size: 1.4rem;
  }
  & .MuiFormHelperText-root {
    font-size: 1.2rem;
  }

`;

interface IButton {
  bgcolor?: 'primary' | 'secondary';
  fullWidth?: boolean;
}

export const Button = styled(MuiButton) <IButton>`
  &.MuiButtonBase-root {
    background: ${({ bgcolor }) => bgcolor === 'secondary' ? 'var(--black)' : 'var(--orange)'};
    color: ${({ bgcolor }) => bgcolor === 'secondary' ? 'var(--black)' : 'var(--white)'};
    height: 40px;
    font-size: 1.4rem;
    text-transform: uppercase;
    width: 100%;
    @media(min-width: 600px) {
      width: ${({ fullWidth }) => fullWidth ? '100%' : '160px'};
    }
    /* @media(min-width: 1920px) {
      height: 50px;
      font-size: 1.4rem;
    } */
  }
  &.MuiButton-root:hover {
    background-color: ${({ bgcolor }) => bgcolor === 'secondary' ? 'var(--grayHover)' : 'var(--orangeHover)'};
    cursor: pointer;
  }
`;

export const ButtonCancelIcon = styled(MuiButton) <IButton>`
  &.MuiButtonBase-root {
    background-color: #FFF;
    color: var(--orange);
    border: 1px solid var(--orange);
    height: 40px;
    font-size: 1.4rem;
    text-transform: uppercase;
    width: 100%;
    @media(min-width: 600px) {
      width: ${({ fullWidth }) => fullWidth ? '100%' : '160px'};
    }
    /* @media(min-width: 1920px) {
      height: 50px;
      font-size: 1.4rem;
    } */
  }
  &.MuiButton-root:hover {
    background-color: var(--backgroundContent);
    cursor: pointer;
  }
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  & .MuiTypography-body1 {
    color: var(--color-gray);
    font-size: 1.4rem;
  }
`;

export const P = styled.p`
  margin-top: 20px;
  font-size: 1.4rem;
  color: var(--grayLv1);
  text-align: center;
`;

export const Span = styled.span`
  cursor: pointer;
  transition: all 0.2s;
  &:hover{
    color: var(--grayLv4);
  }
`;

export const Paper = styled(MuiPaper)`
  padding: 32px;
  margin-top: 32px;
`;

export const FormTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--grayLv3);
`;

export { default as ButtonSubmit } from './ButtonSubmit';
export { default as ButtonAdd } from './ButtonAdd';
export { default as ButtonCancel } from './ButtonCancel';
export { default as DatePicker } from './DatePicker';
export { default as DateTimePicker } from './DateTimePicker';
export { default as Autocomplete } from './Autocomplete';
export { default as Multiline } from './Multiline';